import { motion } from 'framer-motion';
import PlaceholderText from '../../../public/images/placeholderText.svg';
import PlaceholderHead from '../../../public/images/placeholderHead.svg';
import styles from '../../../styles/modules/promotion/referral/ReferralPreferences.module.scss';

const ReferralPreferences = () => {
  return (
    <section className="block">
      <div className="fixed">
        <div className={styles.preferences}>
          <h3 className={styles.preferencesTitle}>Выгода для тебя и друга</h3>
          <div className={styles.preferencesDescription}>
            Сколько — зависит от того, какую услугу друг оформит по твоей ссылке
          </div>
          <div className={styles.preferencesList}>
            <div className={styles.preferencesListItem}>
              <div className={styles.preferencesListItemPointer}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="73"
                  viewBox="0 0 16 73"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <path d="M9.8 1L4.60601 10.275C1.82154 15.2473 2.32889 21.4111 5.88893 25.8612L7.00342 27.2543C11.0939 32.3673 11.0904 39.6369 7 44.75V44.75C2.90955 49.8631 2.90613 57.1327 6.99658 62.2457L14 71" />
                </svg>
              </div>
              <div className={styles.preferencesListItemContent}>
                <div className={styles.preferencesListItemTitle}>
                  Продажа квартиры, дома, земельного участка
                </div>
                <div className={styles.preferencesListItemDescription}>
                  <span className={styles.bold}>5000 рублей</span> тебе, другу –{' '}
                  <span className={styles.bold}>25% скидка</span> на услуги
                </div>
              </div>
            </div>
            <div className={styles.preferencesListItem}>
              <div className={styles.preferencesListItemPointer}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="73"
                  viewBox="0 0 16 73"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <path d="M9.8 1L4.60601 10.275C1.82154 15.2473 2.32889 21.4111 5.88893 25.8612L7.00342 27.2543C11.0939 32.3673 11.0904 39.6369 7 44.75V44.75C2.90955 49.8631 2.90613 57.1327 6.99658 62.2457L14 71" />
                </svg>
              </div>
              <div className={styles.preferencesListItemContent}>
                <div className={styles.preferencesListItemTitle}>
                  Покупка квартиры, дома, земельного участка
                </div>
                <div className={styles.preferencesListItemDescription}>
                  <span className={styles.bold}>5000 рублей</span> тебе, другу –{' '}
                  <span className={styles.bold}>25% скидка</span> на услуги
                </div>
              </div>
            </div>
            <div className={styles.preferencesListItem}>
              <div className={styles.preferencesListItemPointer}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="73"
                  viewBox="0 0 16 73"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="4"
                  strokeLinejoin="round"
                >
                  <path d="M9.8 1L4.60601 10.275C1.82154 15.2473 2.32889 21.4111 5.88893 25.8612L7.00342 27.2543C11.0939 32.3673 11.0904 39.6369 7 44.75V44.75C2.90955 49.8631 2.90613 57.1327 6.99658 62.2457L14 71" />
                </svg>
              </div>
              <div className={styles.preferencesListItemContent}>
                <div className={styles.preferencesListItemTitle}>Жилая аренда квартиры, дома</div>
                <div className={styles.preferencesListItemDescription}>
                  <span className={styles.bold}>1000 рублей</span> тебе, другу –{' '}
                  <span className={styles.bold}>25% скидка</span> на услуги
                </div>
              </div>
            </div>
          </div>
          <div className={styles.preferencesPlaceholder}>
            <PlaceholderHead className={styles.preferencesPlaceholderHead} />
            <motion.div
              initial={{ rotate: '0deg' }}
              animate={{ rotate: '-360deg' }}
              transition={{ repeat: Infinity, repeatType: 'loop', duration: 15, ease: 'linear' }}
            >
              <PlaceholderText />
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReferralPreferences;
